<section
  class="inventory-worksheet-skeleton-container"
  [ngClass]="
    platform === PlatformEnum.tablet
      ? 'tablet'
      : platform === PlatformEnum.mobile
      ? 'mobile'
      : 'desktop'
  "
>
  <div class="main-container">
    <ng-container
      *ngIf="platform === PlatformEnum.desktop"
      [ngTemplateOutlet]="desktopHeader"
    ></ng-container>
    <ng-container
      *ngIf="platform === PlatformEnum.tablet"
      [ngTemplateOutlet]="tabletHeader"
    ></ng-container>
    <ng-container
      *ngIf="platform === PlatformEnum.mobile"
      [ngTemplateOutlet]="mobileHeader"
    ></ng-container>
    <div class="group-tabs">
      <ion-skeleton-text class="all" animated></ion-skeleton-text>
      <ion-skeleton-text class="unassigned" animated></ion-skeleton-text>
    </div>
    <div class="search-bar">
      <ion-skeleton-text class="search" animated></ion-skeleton-text>
      <div class="add-update">
        <ion-skeleton-text class="button" animated></ion-skeleton-text>
        <ion-skeleton-text class="button" animated></ion-skeleton-text>
      </div>
    </div>
    <div class="topper">
      <ion-skeleton-text class="group-name" animated></ion-skeleton-text>
      <ion-skeleton-text
        *ngIf="platform === PlatformEnum.desktop"
        class="sort"
        animated
      ></ion-skeleton-text>
    </div>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
    <ion-skeleton-text class="item" animated></ion-skeleton-text>
  </div>
</section>

<ng-template #desktopHeader>
  <div class="breadcrumb-bar">
    <ion-skeleton-text class="breadcrumbs" animated></ion-skeleton-text>
    <ion-skeleton-text class="download" animated></ion-skeleton-text>
  </div>
  <ion-skeleton-text class="title" animated></ion-skeleton-text>
  <div class="timestamps">
    <ion-skeleton-text class="date" animated></ion-skeleton-text>
    <ion-skeleton-text class="date" animated></ion-skeleton-text>
  </div>
</ng-template>

<ng-template #tabletHeader>
  <div class="title-bar">
    <ion-skeleton-text class="title" animated></ion-skeleton-text>
    <ion-skeleton-text class="value" animated></ion-skeleton-text>
  </div>
  <div class="timestamps-toggle">
    <div class="timestamps">
      <ion-skeleton-text class="date" animated></ion-skeleton-text>
      <ion-skeleton-text class="date" animated></ion-skeleton-text>
    </div>
    <div class="toggle-bar">
      <ion-skeleton-text class="toggle" animated></ion-skeleton-text>
      <ion-skeleton-text class="ellipsis" animated></ion-skeleton-text>
    </div>
  </div>
</ng-template>

<ng-template #mobileHeader>
  <div class="toggle-bar">
    <ion-skeleton-text class="toggle" animated></ion-skeleton-text>
    <ion-skeleton-text class="ellipsis" animated></ion-skeleton-text>
  </div>
  <ion-skeleton-text class="title" animated></ion-skeleton-text>
  <div class="timestamps">
    <ion-skeleton-text class="date" animated></ion-skeleton-text>
    <ion-skeleton-text class="date" animated></ion-skeleton-text>
  </div>
</ng-template>
